import { Component } from "react";

/**
 * App-wide error boundary. Prevents a single render error from blanking the
 * whole app (white screen). Shows a friendly recoverable message instead.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("App render error:", error, info?.componentStack);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#f1f5f9", padding: 24 }}>
        <div style={{ maxWidth: 420, textAlign: "center", background: "#fff", borderRadius: 16, padding: 32, boxShadow: "0 10px 30px rgba(15,23,42,0.08)" }}>
          <div style={{ width: 56, height: 56, borderRadius: 28, background: "#E8EEF5", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#00305E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
          </div>
          <h2 style={{ fontSize: 20, fontWeight: 800, color: "#0f172a", marginBottom: 8 }}>Something went wrong</h2>
          <p style={{ fontSize: 14, color: "#64748b", marginBottom: 20 }}>The page hit an unexpected error. Your data is safe — reload to continue. If it keeps happening, let us know what you were doing.</p>
          <button
            data-testid="error-boundary-reload"
            onClick={this.handleReload}
            style={{ background: "#00305E", color: "#fff", border: "none", padding: "12px 24px", borderRadius: 12, fontWeight: 700, fontSize: 15, cursor: "pointer" }}
          >
            Reload page
          </button>
        </div>
      </div>
    );
  }
}
